import React, { useEffect, useRef, useState } from 'react';
import { Container, Header } from '@cloudscape-design/components';
import { Game, gameApi, GameStatus, Player, playersApi } from '../../api';
import { GameNotStarted } from './GameNotStarted';
import { GameStarted } from './GameStarted';
import { GameScored } from './GameScored';

interface CurrentGameProps {}

export const CurrentGame: React.FC<CurrentGameProps> = () => {
  const [currentGame, setCurrentGame] = useState<Game>({
    status: GameStatus.NotStarted,
  });

  const [players, setPlayers] = useState<Player[]>([]);

  const didLoadingRef = useRef(false);

  useEffect(() => {
    if (didLoadingRef.current) {
      return;
    }
    didLoadingRef.current = true;
    playersApi.list().then((players) => {
      setPlayers(players);
    });
    gameApi.currentGame().then((game) => setCurrentGame(game));
  }, []);

  let content = <></>;

  switch (currentGame.status) {
    case GameStatus.NotStarted:
      content = (
        <GameNotStarted
          players={players}
          onStartGame={() => {
            gameApi
              .start(players)
              .then(() => gameApi.currentGame())
              .then((game) => setCurrentGame(game));
          }}
        />
      );
      break;
    case GameStatus.Started:
      content = (
        <GameStarted
          game={currentGame}
          onGameFinish={() => {
            gameApi.score().then((game) => setCurrentGame(game));
          }}
          onNextPlayer={(points) => {
            gameApi
              .addToScore(points)
              .then(() => gameApi.currentGame())
              .then((game) => setCurrentGame(game));
          }}
        />
      );
      break;
    case GameStatus.Scored:
      content = (
        <GameScored
          game={currentGame}
          onRestartGame={() =>
            gameApi.restart().then((game) => setCurrentGame(game))
          }
        />
      );
      break;
    default:
      content = <>Unknown game state</>;
      break;
  }
  return (
    <Container header={<Header variant="h1">Current Game</Header>}>
      {content}
    </Container>
  );
};
